



















import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'

@Component

export default class ComponentAlvoradaCarater extends Vue {
  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }
}
